import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Helmet } from "react-helmet-async";
import JoinNowFormPopup from "../../../componants/JoinNowFormPopup";

// Helper component for Star Rating
const StarRating = ({ rating }: { rating: number }) => {
  const stars = [];
  for (let i = 1; i <= 5; i++) {
    stars.push(
      <svg
        key={i}
        className={`h-4 w-4 ${
          i <= rating ? "text-yellow-400" : "text-gray-300"
        } inline-block`}
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.538 1.118l-2.8-2.034a1 1 0 00-1.176 0l-2.8 2.034c-.783.57-1.838-.197-1.538-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.381-1.81.588-1.81h3.462a1 1 0 00.95-.69l1.07-3.292z" />
      </svg>
    );
  }
  return <div className="flex items-center">{stars}</div>;
};

// Helper component for Verified Badge
const VerifiedBadge = () => (
  <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 ml-2">
    <svg
      className="w-3 h-3 mr-1"
      fill="currentColor"
      viewBox="0 0 20 20"
    >
      <path
        fillRule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
        clipRule="evenodd"
      />
    </svg>
    Verified
  </span>
);

// Helper component for Google Badge
const GoogleBadge = () => (
    <span className="ml-2">
        <img src="https://www.google.com/images/branding/googleg/1x/googleg_standard_color_128dp.png" alt="Google" className="h-4 w-4 inline-block" />
    </span>
);


const MernStackTrainingInNoida = () => {
  const testimonials = [
    {
      id: 1,
      name: "Aman Singh",
      review:
        "The MERN Stack training at Nadezhda Venture was a game-changer. I mastered React, Node.js, Express, and MongoDB, and now I'm building modern web apps with confidence. Highly recommended!",
      rating: 5,
      date: "2024-07-29",
      profileImg: "https://t4.ftcdn.net/jpg/03/64/21/11/360_F_364211147_1zLk0b3Jz254E0FvgpSfXhVbPvj0G24P.jpg",
      source: "Google",
      verified: true,
    },
    {
      id: 2,
      name: "Priya Sharma",
      review:
        "This MERN course is incredibly comprehensive. From frontend React to backend Node.js and database MongoDB, every module was well-structured. I'm now confidently creating full-stack applications.",
      rating: 4,
      date: "2024-07-28",
      profileImg: "https://image.shutterstock.com/image-photo/young-handsome-man-beard-wearing-260nw-1748111964.jpg",
      source: "Google",
      verified: true,
    },
    {
      id: 3,
      name: "Rahul Verma",
      review:
        "Nadezhda Venture truly offers the best MERN Stack training in Noida. The hands-on projects and expert instructors helped me understand the complete JavaScript ecosystem. Excellent job support!",
      rating: 5,
      date: "2024-07-27",
      profileImg: "https://i.pinimg.com/736x/87/40/3c/87403c9d78e7275085d34237f3743a3d.jpg",
      source: "Google",
      verified: true,
    },
    {
      id: 4,
      name: "Swati Gupta",
      review:
        "After completing my MERN Stack training, I secured a fantastic MERN Developer position. The emphasis on practical skills and real-world projects was invaluable. Supportive and experienced trainers.",
      rating: 4,
      date: "2024-07-26",
      profileImg: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=400&h=400&fit=crop&ixid=eyJhcHBfaWQiOjEyMDd9",
      source: "Google",
      verified: true,
    },
    {
      id: 5,
      name: "Vishal Kumar",
      review:
        "Fantastic MERN Stack course! I gained proficiency in frontend React, backend Node.js with Express, and MongoDB. The learning environment promotes hands-on learning and practical application.",
      rating: 5,
      date: "2024-07-25",
      profileImg: "https://expertphotography.com/wp-content/uploads/2020/08/profile-photos-4.jpg",
      source: "Google",
      verified: true,
    },
    {
      id: 6,
      name: "Deepika Mehta",
      review:
        "This is undoubtedly the leading institute for MERN Stack training in Noida. The comprehensive curriculum, covering everything from React components to API development with Node.js, was exceptional. I feel ready for the industry.",
      rating: 5,
      date: "2024-07-29",
      profileImg: "https://media.licdn.com/dms/image/D4D03AQEaVlXmO6jR-g/profile-displaythumbnail-shrink_200_200/0/1666699268686?e=2147483647&v=beta&t=7u7Wk3P6R7c-M-Y1k3M-2w-N4z-3a-J2q-G6x-B9x-Q",
      source: "Google",
      verified: true,
    },
    {
      id: 7,
      name: "Sagar Das",
      review:
        "I was placed as a MERN Stack Developer after completing my course here. The training on building complete web applications was very thorough. The career support was excellent!",
      rating: 4,
      date: "2024-07-28",
      profileImg: "https://img.freepik.com/free-photo/young-indian-man-posing-outdoor_23-2150756773.jpg?size=626&ext=jpg&ga=GA1.1.1826414947.1699574400&semt=ais",
      source: "Google",
      verified: true,
    },
  ];

  const faqContent = [
    {
      title: "What is MERN Stack Development?",
      answer:
        "MERN Stack is a collection of JavaScript-based technologies used to build dynamic web applications. MERN stands for MongoDB (database), Express.js (backend web framework), React.js (frontend library), and Node.js (JavaScript runtime). It allows developers to build full-stack applications using a single language: JavaScript.",
    },
    {
      title: "What are the prerequisites for joining MERN Stack training?",
      answer:
        "A basic understanding of web concepts and JavaScript is beneficial but not strictly required. Our course starts with JavaScript fundamentals and progresses to cover all MERN technologies, making it suitable for both beginners and those with some programming background.",
    },
    {
      title: "What topics are covered in your MERN Stack course?",
      answer:
        "Our comprehensive course covers HTML5, CSS3, advanced JavaScript (ES6+), React.js (components, state, props, hooks, routing), Node.js fundamentals, Express.js for building RESTful APIs, MongoDB for database management (Mongoose ORM), user authentication (JWT), deployment strategies, and real-time applications with WebSockets (basics).",
    },
    {
      title: "How is the MERN Stack training delivered (online/offline)?",
      answer:
        "We offer flexible training modes including intensive offline classroom sessions at our Noida center and interactive online classes. Both modes feature live instructor-led sessions, extensive practical exercises, and project-based learning to ensure a strong grasp of concepts.",
    },
    {
      title: "Will I get placement assistance after completing the course?",
      answer:
        "Yes, we provide dedicated placement assistance to our MERN Stack graduates. This includes resume building, interview preparation, mock interviews, and connecting you with our network of hiring partners in Noida and across India, for roles requiring modern JavaScript full-stack skills.",
    },
    {
      title: "What kind of projects will I work on during the training?",
      answer:
        "You will work on multiple full-stack projects, building complete web applications from scratch using the MERN stack. Examples include an e-commerce platform, a social media dashboard, a task management system, or a blogging platform, integrating all four MERN components.",
    },
    {
      title: "Is there a certification provided after the MERN Stack course?",
      answer:
        "Yes, upon successful completion of the MERN Stack training and project work, you will receive a course completion certificate from Appwars Technologies, which is highly recognized by industry professionals and validates your comprehensive MERN development skills.",
    },
  ];

   const [isPopupOpen, setIsPopupOpen] = useState(false); // State to control popup visibility
      const [selectedCourseTitle, setSelectedCourseTitle] = useState(""); // State to store the course title
    
      const handleOpenPopup = (courseTitle: string) => { // Function to open the popup
        setSelectedCourseTitle(courseTitle); // Set the selected course title
        setIsPopupOpen(true); // Open the popup
      };
    
      const handleClosePopup = () => { // Function to close the popup
        setIsPopupOpen(false); // Close the popup
        setSelectedCourseTitle(""); // Clear selected course when closing
      };

  const curriculumContent = [
    {
      title: "Module 1: Frontend Fundamentals (HTML5, CSS3, Advanced JavaScript)",
      description: "Mastering HTML for structure, CSS for styling (Flexbox, Grid, responsiveness), and advanced JavaScript (ES6+ features, asynchronous programming, DOM manipulation).",
    },
    {
      title: "Module 2: React.js Fundamentals",
      description: "Introduction to React: components, JSX, props, state, event handling, conditional rendering, and list rendering. Building single-page applications.",
    },
    {
      title: "Module 3: Advanced React.js & React Router",
      description: "Deep dive into React Hooks (useState, useEffect, useContext, useRef), custom hooks, context API, Redux for state management, and React Router for navigation.",
    },
    {
      title: "Module 4: Node.js Basics & NPM",
      description: "Introduction to Node.js runtime, event loop, modules, file system operations, and npm (Node Package Manager) for managing dependencies.",
    },
    {
      title: "Module 5: Express.js for Backend Development",
      description: "Building RESTful APIs with Express.js: routing, middleware, handling requests (GET, POST, PUT, DELETE), and error handling.",
    },
    {
      title: "Module 6: MongoDB & Mongoose ODM",
      description: "Introduction to NoSQL databases, MongoDB concepts, Mongoose ODM for interacting with MongoDB from Node.js, CRUD operations, data modeling, and aggregation.",
    },
    {
      title: "Module 7: Connecting Frontend (React) with Backend (Node/Express)",
      description: "Integrating React frontend with Node.js/Express backend using Axios for HTTP requests, CORS handling, and data flow between client and server.",
    },
    {
      title: "Module 8: User Authentication & Authorization",
      description: "Implementing secure user authentication using JSON Web Tokens (JWT), password hashing, user registration, login, and authorization mechanisms.",
    },
    {
      title: "Module 9: Deployment & Best Practices",
      description: "Deploying MERN Stack applications to cloud platforms (e.g., Heroku, Vercel for frontend, Render for backend). Performance optimization, security best practices, and Git for version control.",
    },
    {
      title: "Module 10: Capstone Project & Portfolio Building",
      description: "Develop a complete, real-world MERN Stack application from scratch, showcasing all learned technologies. Focus on scalability, clean code, and preparing your project for a professional portfolio.",
    },
  ];

  const [currentTestimonialIndex, setCurrentTestimonialIndex] = useState(0);

  useEffect(() => {
    const autoScrollInterval = setInterval(() => {
      setCurrentTestimonialIndex(
        (prevIndex) => (prevIndex + 1) % testimonials.length
      );
    }, 5000); // Auto-slide every 5 seconds

    return () => clearInterval(autoScrollInterval); // Clean up the interval
  }, [testimonials.length]);

  const goToPrevTestimonial = () => {
    setCurrentTestimonialIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const goToNextTestimonial = () => {
    setCurrentTestimonialIndex((prevIndex) =>
      (prevIndex + 1) % testimonials.length
    );
  };

  const getVisibleTestimonialsCount = () => {
    if (window.innerWidth >= 1024) return 3; // lg breakpoint
    if (window.innerWidth >= 768) return 2;  // md breakpoint
    return 1; // default for small screens
  };

  const [visibleCount, setVisibleCount] = useState(getVisibleTestimonialsCount());

  useEffect(() => {
    const handleResize = () => {
      setVisibleCount(getVisibleTestimonialsCount());
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const startIndex = currentTestimonialIndex;
  const currentVisibleTestimonials = [];

  // Logic to handle showing multiple cards and wrapping around
  for (let i = 0; i < visibleCount; i++) {
    currentVisibleTestimonials.push(testimonials[(startIndex + i) % testimonials.length]);
  }

  // State for the enquiry form
  const [formData, setFormData] = useState({
    firstName: "",
    businessEmail: "",
    phone: "",
    courseOfInterest: "MERN Stack Training", // Pre-fill for this page
    collegeName: "",
  });

  const [formStatus, setFormStatus] = useState({
    submitted: false,
    message: "",
    type: "", // 'success' or 'error'
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setFormStatus({ submitted: false, message: "", type: "" }); // Reset status

    try {
      const response = await fetch("/api2/submit-form", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          firstName: formData.firstName,
          businessEmail: formData.businessEmail,
          phone: formData.phone,
          courseOfInterest: formData.courseOfInterest,
          collegeName: formData.collegeName,
          // Default values for fields not explicitly captured on this form, but present in FormSubmissionDto
          lastName: "N/A",
          companyName: "N/A",
          interests: ["MERN Stack Training"],
          howDidYouFindUs: "Website Enquiry (MERN Page)",
          subscribeNewsletter: false,
          message: `Enquiry for ${formData.courseOfInterest} training from MERN page.`,
        }),
      });

      if (response.ok) {
        setFormStatus({
          submitted: true,
          message: "Form submitted successfully! You will receive a confirmation email shortly.",
          type: "success",
        });
        setFormData({ // Clear form
            firstName: "",
            businessEmail: "",
            phone: "",
            courseOfInterest: "MERN Stack Training",
            collegeName: "",
        });
      } else {
        const errorData = await response.json();
        setFormStatus({
          submitted: true,
          message: `Error submitting form: ${errorData.message || response.statusText}`,
          type: "error",
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setFormStatus({
        submitted: true,
        message: "An unexpected error occurred. Please try again later.",
        type: "error",
      });
    }
  };


  return (
    <div className="bg-white text-gray-800">
      <Helmet>
        <title>MERN Stack Training in Noida | Master MongoDB, Express, React, Node.js</title>
        <meta
          name="description"
          content="Become a complete web developer with our MERN Stack training in Noida. Master MongoDB, Express.js, React.js, and Node.js with hands-on projects and placement support."
        />
        <meta
          name="keywords"
          content="MERN Stack training Noida, MERN Stack course, React.js training, Node.js training, Express.js, MongoDB, JavaScript Full Stack, Web Development, MERN certification"
        />
      </Helmet>

      {/* Hero Section */}
      <section className="relative overflow-hidden text-white h-[400px] bg-gray-900 flex items-center">
        <img
          src="https://skills.edu.pk/storage/speciaization/lGjOepQV62aMgFsnHNy5kh8ktjQAYKDUJ8fu83au.jpg"
          alt="MERN Stack Training Background"
          className="absolute inset-0 w-full h-full object-cover z-0"
        />
         {/* Dark overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-60 z-10" />

       <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 md:py-40 flex flex-col md:flex-row items-center md:items-start">
               <div className="md:w-1/2">
                 <motion.h1
                   initial={{ opacity: 0, y: 30 }}
                   animate={{ opacity: 1, y: 0 }}
                   transition={{ duration: 0.8 }}
                   className="text-4xl md:text-5xl font-extrabold leading-tight text-left"
                 >
                   <span className="text-blue-500">MERN Stack</span> Training in Noida
                 </motion.h1>
       
                 <motion.p
                   initial={{ opacity: 0, y: 20 }}
                   animate={{ opacity: 1, y: 0 }}
                   transition={{ delay: 0.3, duration: 0.8 }}
                   className="mt-6 text-lg md:text-xl text-gray-200 text-left"
                 >
                   Master modern web development with our comprehensive MERN Stack training in Noida. Build dynamic and scalable web applications.
                 </motion.p>
       
                 <motion.button
                   initial={{ opacity: 0, y: 20 }}
                   animate={{ opacity: 1, y: 0 }}
                   transition={{ delay: 0.6, duration: 0.8 }}
                   className="mt-8 bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-full shadow-lg transition duration-300 ease-in-out"
                 >
                    <button
                    // className="bg-orange-600 hover:bg-orange-700 px-6 py-3 rounded-lg font-semibold transition text-white"
                    onClick={() => handleOpenPopup("Mern Full Stack Development Training")} // Pass the course title
                  >
                    Enroll Now !
                  </button>
                 </motion.button>
               </div>
               </div>
      </section>

      {/* Why MERN Stack Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-blue-900">Why Learn MERN Stack Development?</h2>
          <p className="text-lg text-gray-700 mb-8 max-w-3xl mx-auto">
            MERN Stack development is highly sought after for building modern, scalable, and robust web applications. By mastering this stack, you leverage the power of JavaScript across the entire application, streamlining development and boosting efficiency.
          </p>
          <div className="grid md:grid-cols-3 gap-8 mt-10">
            <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
              <h3 className="font-semibold text-xl text-blue-700 mb-3">JavaScript Everywhere</h3>
              <p className="text-gray-600">Use a single language for both frontend and backend, simplifying development.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
              <h3 className="font-semibold text-xl text-blue-700 mb-3">High Industry Demand</h3>
              <p className="text-gray-600">MERN developers are in high demand for creating dynamic, single-page applications.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
              <h3 className="font-semibold text-xl text-blue-700 mb-3">Robust & Scalable</h3>
              <p className="text-gray-600">Build powerful, scalable applications suitable for various business needs.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Course Highlights Section */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center text-blue-900">Course Highlights</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { icon: '🚀', title: 'Complete MERN Project Development', desc: 'Build full-fledged web applications from frontend React to backend Node.js and MongoDB.' },
              { icon: '💡', title: 'JavaScript Full Stack Mastery', desc: 'Proficiency in React.js, Node.js, Express.js, and MongoDB.' },
              { icon: '👨‍🏫', title: 'Experienced Industry Trainers', desc: 'Learn from MERN stack experts with practical industry insights.' },
              { icon: '🎓', title: 'Globally Recognized Certification', desc: 'Enhance your profile with our industry-aligned course certificate.' },
              { icon: '🤝', title: 'Dedicated Placement Assistance', desc: 'Comprehensive support for resume building, mock interviews, and job placements.' },
              { icon: '🔄', title: 'Flexible Learning Options', desc: 'Choose between immersive offline classroom or interactive online sessions.' },
            ].map((item, index) => (
              <motion.div
                key={index}
                className="bg-blue-50 p-6 rounded-lg shadow-md flex items-start space-x-4"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <div className="text-4xl">{item.icon}</div>
                <div>
                  <h3 className="font-semibold text-xl text-blue-800 mb-2">{item.title}</h3>
                  <p className="text-gray-700">{item.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Curriculum Overview Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center text-blue-900">Detailed Curriculum Overview</h2>
          <div className="space-y-4">
            {curriculumContent.map((module, idx) => (
              <div
                key={idx}
                className="border border-gray-200 rounded-lg shadow-sm overflow-hidden bg-white"
              >
                <details className="group">
                  <summary className="cursor-pointer px-6 py-4 font-semibold text-lg bg-gray-50 hover:bg-gray-100 transition duration-200 ease-in-out flex justify-between items-center">
                    {module.title}
                    <span className="transform transition-transform duration-200 group-open:rotate-180">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </span>
                  </summary>
                  <div className="px-6 py-4 text-gray-700 leading-relaxed border-t border-gray-200">
                    <p>{module.description}</p>
                  </div>
                </details>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Tools & Technologies */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-blue-900">Tools & Technologies You'll Master</h2>
          <p className="text-lg text-gray-700 mb-10 max-w-3xl mx-auto">
            Our MERN Stack training ensures you gain proficiency in all essential technologies for modern web development.
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8 items-center justify-center">
            {[
              { name: 'MongoDB', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg' },
              { name: 'Express.js', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg' },
              { name: 'React', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg' },
              { name: 'Node.js', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg' },
              { name: 'JavaScript', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg' },
              { name: 'HTML5', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg' },
              { name: 'CSS3', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg' },
              { name: 'VS Code', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vscode/vscode-original.svg' },
              { name: 'Git', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg' },
              { name: 'npm', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/npm/npm-original-wordmark.svg' },
              { name: 'Yarn', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/yarn/yarn-original.svg' },
              { name: 'Postman', logo: 'https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg' },
            ].map((tool, index) => (
              <motion.div
                key={index}
                className="flex flex-col items-center p-4 bg-gray-100 rounded-lg shadow-sm"
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.4, delay: index * 0.05 }}
              >
                <img src={tool.logo} alt={tool.name} className="h-12 mb-2" />
                <p className="text-gray-700 font-medium text-sm">{tool.name}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Career Opportunities */}
      <section className="py-16 bg-blue-50">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-blue-900">Exciting Career Opportunities</h2>
          <p className="text-lg text-gray-700 mb-10 max-w-3xl mx-auto">
            A MERN Stack certification from Appwars Technologies opens doors to high-demand roles in modern web development.
          </p>
          <div className="grid md:grid-cols-3 gap-8">
            {[
              { icon: '🌟', title: 'MERN Stack Developer', desc: 'Build full-stack web applications using MongoDB, Express.js, React, and Node.js.' },
              { icon: '💻', title: 'Frontend React Developer', desc: 'Specialize in creating dynamic and interactive user interfaces with React.js.' },
              { icon: '🌐', title: 'Backend Node.js Developer', desc: 'Focus on server-side logic, APIs, and database interactions using Node.js and Express.js.' },
              { icon: '✨', title: 'Full Stack JavaScript Developer', desc: 'Develop across the entire web stack using JavaScript and its frameworks.' },
              { icon: '🚀', title: 'Web Application Architect', desc: 'Design and plan the architecture of complex web applications.' },
              { icon: '🛠️', title: 'Software Engineer (Web)', desc: 'Contribute to the development of web-based software solutions.' },
            ].map((role, index) => (
              <motion.div
                key={index}
                className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 flex flex-col items-center text-center"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <div className="text-5xl mb-4">{role.icon}</div>
                <h3 className="font-semibold text-xl text-blue-800 mb-2">{role.title}</h3>
                <p className="text-gray-700">{role.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>


      {/* Course Content / FAQ Section */}
      <section className="max-w-6xl mx-auto px-4 py-16 grid md:grid-cols-3 gap-10">
        <div className="md:col-span-2">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center md:text-left">Frequently Asked Questions</h2>
          <div className="space-y-4">
            {faqContent.map((section, idx) => (
              <div
                key={idx}
                className="border border-gray-200 rounded-lg shadow-sm overflow-hidden bg-white"
              >
                <details className="group">
                  <summary className="cursor-pointer px-6 py-4 font-semibold text-lg bg-gray-50 hover:bg-gray-100 transition duration-200 ease-in-out flex justify-between items-center">
                    {section.title}
                    <span className="transform transition-transform duration-200 group-open:rotate-180">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </span>
                  </summary>
                  <div className="px-6 py-4 text-gray-700 leading-relaxed border-t border-gray-200">
                    <p>{section.answer}</p>
                  </div>
                </details>
              </div>
            ))}
          </div>
        </div>

        {/* Enquiry Form */}
        <div className="md:col-span-1 pt-20">
          <div className="bg-blue-300 rounded-lg p-6 shadow-xl">
            <h3 className="text-2xl font-bold mb-4 text-center text-blue-800">Enquire Now</h3>
            <p className="text-center text-gray-600 mb-6">Fill out the form below to get more details about our MERN Stack training program.</p>
            <form className="space-y-4" onSubmit={handleSubmit}>
              <input
                type="text"
                name="firstName"
                placeholder="Your Name"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={formData.firstName}
                onChange={handleInputChange}
                required
              />
              <input
                type="text"
                name="courseOfInterest"
                placeholder="Course of Interest (e.g., MERN Stack Training)"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={formData.courseOfInterest}
                onChange={handleInputChange}
                required
              />
              <input
                type="text"
                name="collegeName"
                placeholder="College/University Name"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={formData.collegeName}
                onChange={handleInputChange}
              />
              <input
                type="email"
                name="businessEmail"
                placeholder="Your Email"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={formData.businessEmail}
                onChange={handleInputChange}
                required
              />
              <input
                type="tel"
                name="phone"
                placeholder="Phone Number"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={formData.phone}
                onChange={handleInputChange}
                required
              />
              <button
                type="submit"
                className="w-full bg-blue-800 hover:bg-blue-700 text-white py-3 rounded-md font-semibold transition duration-300 ease-in-out shadow-md hover:shadow-lg"
              >
                JOIN THE PROGRAM
              </button>
              {formStatus.submitted && (
                <div
                  className={`mt-4 p-3 rounded-md text-center ${
                    formStatus.type === "success"
                      ? "bg-green-100 text-green-800"
                      : "bg-red-100 text-red-800"
                  }`}
                >
                  {formStatus.message}
                </div>
              )}
            </form>
          </div>
        </div>
      </section>

      {/* Testimonial Section - No Horizontal Scrollbar */}
      <section className="bg-blue-50 py-16">
        <div className="max-w-7xl mx-auto px-4 text-center relative">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-blue-900">Our Students Say</h2>

          <div className="relative overflow-hidden w-full mx-auto">
            {/* Left Scroll Button */}
            <button
              onClick={goToPrevTestimonial}
              className="absolute left-0 top-1/2 -translate-y-1/2 z-10 p-3 bg-white rounded-full shadow-lg hover:bg-gray-100 transition-colors duration-300 hidden md:block"
              aria-label="Previous testimonial"
            >
              <svg
                className="w-6 h-6 text-gray-700"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M15 19l-7-7 7-7"
                ></path>
              </svg>
            </button>

            {/* Testimonial Cards Container */}
            <div className="flex justify-center items-stretch space-x-6 md:space-x-8 lg:space-x-10">
              <AnimatePresence mode="wait" initial={false}>
                {currentVisibleTestimonials.map((testimonial, idx) => (
                  <motion.div
                    key={testimonial.id}
                    initial={{ opacity: 0, x: idx * 100 }} // Initial position based on index in visible set
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -100 }}
                    transition={{ duration: 0.5, ease: "easeOut" }}
                    className="flex-none w-full md:w-[calc(50%-1.5rem)] lg:w-[calc(33.333%-2rem)] p-2"
                  >
                    <div className="bg-white p-6 rounded-lg shadow-md border border-gray-100 flex flex-col h-full text-left">
                      <div className="flex items-center mb-4">
                        <img
                          src={testimonial.profileImg}
                          alt={testimonial.name}
                          className="w-12 h-12 rounded-full object-cover mr-4 border-2 border-blue-200"
                        />
                        <div>
                          <p className="font-bold text-gray-900 text-lg">
                            {testimonial.name}
                          </p>
                          <p className="text-gray-500 text-sm">{testimonial.date}</p>
                        </div>
                        {testimonial.source === "Google" && <GoogleBadge />}
                      </div>
                      <div className="flex items-center mb-3">
                        <StarRating rating={testimonial.rating} />
                        {testimonial.verified && <VerifiedBadge />}
                      </div>
                      <p className="text-gray-700 text-base leading-relaxed flex-grow line-clamp-4">
                        {testimonial.review}
                      </p>
                      <a href="#" className="text-blue-600 hover:underline mt-4 text-sm text-right">
                        Read more
                      </a>
                    </div>
                  </motion.div>
                ))}
              </AnimatePresence>
            </div>

            {/* Right Scroll Button */}
            <button
              onClick={goToNextTestimonial}
              className="absolute right-0 top-1/2 -translate-y-1/2 z-10 p-3 bg-white rounded-full shadow-lg hover:bg-gray-100 transition-colors duration-300 hidden md:block"
              aria-label="Next testimonial"
            >
              <svg
                className="w-6 h-6 text-gray-700"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 5l7 7-7 7"
                ></path>
              </svg>
            </button>
          </div>

          {/* Dot Indicators */}
          <div className="flex justify-center mt-8 space-x-2">
            {testimonials.map((_, idx) => (
              <button
                key={idx}
                className={`h-3 w-3 rounded-full ${
                  // Logic to highlight dots based on the current set of visible testimonials
                  idx >= currentTestimonialIndex && idx < currentTestimonialIndex + visibleCount
                    ? "bg-blue-600"
                    : "bg-gray-300"
                } transition-colors duration-300`}
                onClick={() => setCurrentTestimonialIndex(idx)}
                aria-label={`Go to testimonial group ${idx + 1}`}
              ></button>
            ))}
          </div>
        </div>
      </section>

       {/* Conditionally render the popup */}
            {isPopupOpen && (
              <JoinNowFormPopup
                onClose={handleClosePopup}
                courseTitle={selectedCourseTitle}
              />
            )}
    </div>
  );
};

export default MernStackTrainingInNoida;